'use client';

import { useRef } from 'react';
import { TextLink, LogoTreatsRewards, Drawer as DrawerSparky, Image } from '@petsmart-ui/sparky';
import { useCart } from '@libs/common-next';
import { CurrentTierLevel } from '@libs/common-types';
import { LoggedInNavList } from './LoggedInNavList';
import { formatCurrency, navigationItems, getTierImage } from './utils';

import './LoggedIn.scss';

type LoggedInDrawerProps = {
    firstName?: string;
    loyaltyPoints?: number;
    currentTierLevel?: CurrentTierLevel;
    availableDollars?: number;
    isActive?: boolean;
    onClose?: (e: React.MouseEvent | React.KeyboardEvent) => void;
};

export function LoggedInDrawer({
    firstName = '',
    loyaltyPoints = 0,
    currentTierLevel = 'member',
    availableDollars = 0,
    isActive = false,
    onClose,
}: Readonly<LoggedInDrawerProps>) {
    const link = useRef<string>('');
    const { clearCart } = useCart();

    if (!firstName) {
        return null;
    }

    const tierImagename = getTierImage(currentTierLevel) ?? '';

    return (
        <DrawerSparky
            className="drawer logged-in"
            data-testid="header-drawer-logged-in"
            isActive={isActive}
            onClose={onClose}
        >
            <DrawerSparky.Header>
                <div className="member">
                    <span> Hi, {firstName}!</span>
                </div>
            </DrawerSparky.Header>
            <DrawerSparky.Body className="drawer-body logged-in">
                <div className="treats-container">
                    <div className="mobile-member">
                        <div className="loyalty">
                            <span className="treats-points"> {formatCurrency(availableDollars)} Treats balance</span>
                            <span className="dollar-points">
                                (
                                {` ${new Intl.NumberFormat('en-US', {
                                    maximumFractionDigits: 0,
                                }).format(loyaltyPoints || 0)} `}
                                ) points
                            </span>
                        </div>
                        <div className="member">
                            <span className="tier-status">
                                {currentTierLevel?.charAt(0).toUpperCase() + currentTierLevel?.slice(1)}
                                <Image
                                    className="tier-image"
                                    data-testid="member-image"
                                    src={tierImagename}
                                    alt={currentTierLevel}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="treats-rewards">
                        <LogoTreatsRewards className="treats-logo" />
                        <TextLink href="/treats-rewards" className="benefits">
                            See benefits
                        </TextLink>
                    </div>
                </div>
                <LoggedInNavList linkRef={link} clearCart={clearCart} items={navigationItems} />
            </DrawerSparky.Body>
        </DrawerSparky>
    );
}
